// removed by extract-text-webpack-plugin
module.exports = {"root":"AutosuggestPart-module-root-3DVLC","home":"AutosuggestPart-module-home-khWJv","hint":"AutosuggestPart-module-hint-13pxX","arrow":"AutosuggestPart-module-arrow-1emAj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutosuggestPart/AutosuggestPart.module.scss
// module id = 976
// module chunks = 0